/**
 * @desc 分页查询退货单
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(params: API.omsFlow.asMaterialRejectBill.page.Params, options?: any) {
  return updateResponse(
    http(URL + `/asMaterialRejectBill/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
